// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"b20a4955","347":"933f3216","494":"ee01b0b1","523":"b5733784","570":"612336d5","714":"392a3052","946":"56007a15"}[chunkId] + ".chunk.js";
};